export default "__VITE_ASSET__bplNeuAn__"